import { TableColumn, parseDefaultTableColumns } from '../../../../context/shared/tableColumns';
import { Organization } from '../../../../domain/backoffice/organization/Organization';

export const organizationsTableColumnKeys = [
  `name`,
  `external_services`,
  `country`,
  `subscription_plan`,
  `contract_enabled`,
  `subscription_licenses`,
  `users`,
  `projects`,
  `emails_usage`,
  `whatsapp_enabled`,
  `remaining_whatsapp`,
  `sms_enabled`,
  `remaining_sms`,
  `geocode_credit`,
  `payment_status`,
  `payment_date`,
  `created_at`,
] as const;

export type OrganizationsTableColumnKeys = (typeof organizationsTableColumnKeys)[number];

export type OrganizationsTableColumn = TableColumn<OrganizationsTableColumnKeys, Organization>;

export const ORGANIZATIONS_DEFAULT_TABLE_COLUMNS: Array<OrganizationsTableColumn> = [
  {
    identifier: `name`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `external_services`,
    type: `Array`,
    displayable: true,
    filterable: false,
    sortable: false,
  },
  {
    identifier: `country`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `subscription_plan`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `contract_enabled`,
    type: `boolean`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `subscription_licenses`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `users`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `projects`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `emails_usage`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `whatsapp_enabled`,
    type: `boolean`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `remaining_whatsapp`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `sms_enabled`,
    type: `boolean`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `remaining_sms`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `geocode_credit`,
    type: `number`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `payment_status`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `payment_date`,
    type: `Date`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `created_at`,
    type: `Date`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
];

export const getOrganizationsTableColumns = (): Array<OrganizationsTableColumn> => {
  const storedTableColumns = localStorage.getItem(`BACKOFFICE_ORGANIZATIONS_TABLE_COLUMNS`);
  if (!storedTableColumns) return ORGANIZATIONS_DEFAULT_TABLE_COLUMNS;

  const parsedTableColumns = JSON.parse(storedTableColumns);

  // Final table columns should have the current ones.
  const finalTableColumns: Array<OrganizationsTableColumn> = [
    ...(Array.isArray(parsedTableColumns) ? parsedTableColumns : []),
  ];

  return parseDefaultTableColumns({
    finalTableColumns,
    defaultTableColumns: ORGANIZATIONS_DEFAULT_TABLE_COLUMNS,
  });
};

export const setOrganizationsTableColumns = (tableColumns: Array<OrganizationsTableColumn>) => {
  localStorage.setItem(`BACKOFFICE_ORGANIZATIONS_TABLE_COLUMNS`, JSON.stringify(tableColumns));
};
